module.exports = __webpack_public_path__ + "media/audio1.433a50ca.wav";